/*
 * File: ui-submit-wrap.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-18 07:38:50
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagRuleUnion,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    UITag,
} from "../core";
import { lang } from "@root/core/i18n";

// @uiSubmitWrap - wrap the submitted result with one nested level, with the given name.
// default to "data".

// Rule: true | false | [string] (wrap name)
@UITag.set({
    default: true,
})
export class uiSubmitWrap extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.FormSubmit];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Boolean, EUITagRuleType.String];
    allowNullRule: boolean = true; /// default: data

    /// set props :description
    parse(input: IUITagInput): IUITagResult | null {
        /// undefined value turns to the same as default.
        const parsed = this.parseRule(input);
        /// if true, fallback to default value
        const rule =
            parsed === false
                ? false
                : (typeof parsed === "string" ? parsed : "data") ?? "data";

        let specials: IUITagResult["specials"];

        if (rule === false) {
            /// cancel the wrap
            specials = { submitWrap: null };
        } else {
            /// apply the wrap
            specials = { submitWrap: rule as string };
        }

        /// normal case
        return { specials };
    }
}
